import React, { FC } from 'react';
import styled from 'styled-components';
import CookieConsent from 'react-cookie-consent';
import { Link } from 'gatsby';

import { mediaQuery } from 'src/themes/breakpoints';
import { colors } from 'src/themes/colors';

const ContainerWrapper = styled.div`
  .cookie-bar__container {
    align-items: center;
    background-color: ${colors.blue};
    bottom: 0;
    box-shadow: -1px -1px 6px 1px rgba(50, 50, 50, 0.75);
    box-sizing: border-box;
    color: ${colors.white};
    display: flex;
    flex-direction: column;
    font-size: 12px;
    justify-content: space-between;
    padding: 10px 20px;
    position: fixed;
    right: 0;
    text-align: center;
    z-index: 12;
    ${mediaQuery('md')} {
      text-align: left;
      width: 300px;
    }
  }

  .cookie-bar__btn-container {
    display: flex;
    flex: 1 0 20%;
    justify-content: space-evenly;
    margin-top: 15px;
  }

  .cookie-bar__btn {
    background-color: ${colors.orange500};
    border: 1px solid ${colors.orange500};
    border-radius: 3px;
    color: ${colors.white};
    cursor: pointer;
    margin: 0 5px;
    min-width: 100px;
    padding: 5px 20px;
    text-transform: uppercase;
  }

  .cookie-bar__btn--decline {
    background-color: transparent;
    border: 1px solid ${colors.white};
    color: ${colors.white};
  }
`;

const StyledLink = styled(Link)`
  color: ${colors.white};
  text-decoration: underline;
`;

const CookieBar: FC = () => (
  <ContainerWrapper>
    <CookieConsent
      enableDeclineButton
      buttonText="Accept"
      declineButtonText="Decline"
      disableStyles={true}
      // cookieName="gatsby-gdpr-google-analytics" Add yours cookie name here
      containerClasses="cookie-bar__container"
      declineButtonClasses="cookie-bar__btn cookie-bar__btn--decline"
      buttonWrapperClasses="cookie-bar__btn-container"
      buttonClasses="cookie-bar__btn"
    >
      We use cookies on our website to give you the most relevant experience. By
      clicking “Accept”, you consent to the use of ALL the cookies. Read more:{' '}
      <StyledLink to="/data-protection">Data protection</StyledLink>.
    </CookieConsent>
  </ContainerWrapper>
);

export default CookieBar;
